export const ClientActionTypes = {
    GET_FIREARMS: 'GET_FIREARMS',
    GET_FIREARM_DETAIL: 'GET_FIREARM_DETAIL',
    GET_ACCESSORIES: 'GET_ACCESSORIES',
    GET_PARTS: 'GET_PARTS',
    CREATE_FIREARMS: 'CREATE_FIREARMS',
    UPDATE_FIREARMS: 'UPDATE_FIREARMS',

    // classification
    GET_MAKES: 'GET_MAKES',
    GET_MODELS: 'GET_MODELS',
    GET_SAFE_TYPES: 'GET_SAFE_TYPES',
    GET_SAFE_SUB_TYPES: 'GET_SAFE_SUB_TYPES',
    GET_COMPONENTS: 'GET_COMPONENTS',
    GET_CONTACT_CATEGORIES: 'GET_CONTACT_CATEGORIES',
    GET_CONTACT_TOPICS: 'GET_CONTACT_TOPICS',
    GET_ISSUE: 'GET_ISSUE',
    GET_SAFE_MAKE: 'GET_SAFE_MAKE',
    GET_SAFE_MODEL: 'GET_SAFE_MODEL',
    GET_STORAGE_TYPES: 'GET_STORAGE_TYPES',
    GET_CLASSIFICATIONS_SUGGESTION: 'GET_CLASSIFICATIONS_SUGGESTION',

    // reground
    GET_CITIES: 'GET_CITIES',
    GET_STATES: 'GET_STATES',
    GET_ZIPS: ' GET_ZIPS',
    GET_COUNTRIES: 'GET_COUNTRIES',
    CLEAR_STATES: 'CLEAR_STATES',
    CLEAR_CITIES: 'CLEAR_CITIES',

    // firearm
    GET_ACCESSORY_STATE: 'GET_ACCESSORY_STATE',
    GET_ACCESSORY_CITY: 'GET_ACCESSORY_CITY',
    GET_PART_STATE: 'GET_PART_STATE',
    GET_PART_CITY: 'GET_PART_CITY',

    // my vault
    GET_ITEM_STOLEN_OR_LOST: 'GET_ITEM_STOLEN_OR_LOST',
    SUBMIT_ITEM_STOLEN_OR_LOST: 'SUBMIT_ITEM_STOLEN_OR_LOST',
    GET_MY_VAULT_FIREARMS: 'GET_MY_VAULT_FIREARMS',
    GET_INSTRUCTION_LETTER: 'GET_INSTRUCTION_LETTER',

    // safe storage
    GET_SAFE_STORAGES: 'GET_SAFE_STORAGES',

    GET_SAFE_STORAGE_MAKES: 'GET_SAFE_STORAGE_MAKES',
    GET_SAFE_STORAGE_MODELS: 'GET_SAFE_STORAGE_MODELS',

    // insurances
    GET_INSURANCES: 'GET_INSURANCES',

    // Dispose of Firearm
    CREATE_DISPOSE_ITEM: 'CREATE_DISPOSE_ITEM',

    // firearm anomaly
    GET_FIREARM_ANOMALIES: 'GET_FIREARM_ANOMALIES',
    SET_FIREARM_ANOMALY_LOADING: 'SET_FIREARM_ANOMALY_LOADING',
    SET_FIREARM_ANOMALY_QUERIES: 'SET__FIREARM_ANOMALY_QUERIES',

    // profile
    GET_PROFILE: 'GET_PROFILE',

    // my account
    GET_INVOICES: 'GET_INVOICES',
    GET_PAYMENTS: 'GET_PAYMENTS',

    // ammunition
    GET_AMMUNITION: 'GET_AMMUNITION',

    // inspection (inspectors)
    GET_INSPECTIONS: 'GET_INSPECTIONS',
    GET_INSPECTORS: 'GET_INSPECTORS',
    SET_INSPECTOR_QUERIES: 'SET_INSPECTOR_QUERIES',
    SET_INSPECTOR_LOADING: 'SET_INSPECTOR_LOADING',
    // inspection (inspection-schedules)
    GET_INSPECTION_SCHEDULES: 'GET_INSPECTION_SCHEDULES',
    GET_INSPECTION_SCHEDULE: 'GET_INSPECTION_SCHEDULE',
    SET_INSPECTION_SCHEDULE_QUERIES: 'SET_INSPECTION_SCHEDULE_QUERIES',
    SET_INSPECTION_SCHEDULE_LOADING: 'SET_INSPECTION_LOADING',

    // contact
    GET_CONTACTS: 'GET_CONTACTS',
    GET_MESSAGES: 'GET_MESSAGES',
}

export const ItemTypes = {
    STORAGE: 'STORAGE',
    ACCESSORY: 'ACCESSORY',
    FIREARM: 'FIREARM',
    AMMUNITION: 'AMMUNITION',
    PART: 'PART',
}

export const RegroundTypes = {
    CITY: 'CITY',
    STATE: 'STATE',
    ZIP: 'ZIP',
    COUNTRY: 'COUNTRY',
    ACCESSORY_STATE: 'ACCESSORY_STATE',
    ACCESSORY_CITY: 'ACCESSORY_CITY',
    PART_STATE: 'PART_STATE',
    PART_CITY: 'PART_CITY',
}
